import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  serverTimestamp,
  query,
  where,
  orderBy,
  getDocs,
  setDoc,
  doc,
  onSnapshot
} from 'firebase/firestore';

export const mindfulnessService = {
  subscribeSessions(userId, callback) {
    const sessionsRef = collection(db, 'mindfulness');
    const sessionsQuery = query(
      sessionsRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );
    
    return onSnapshot(sessionsQuery, (snapshot) => {
      const sessions = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      callback(sessions);
    });
  },

  async createSession(userId, sessionData) {
    const timestamp = serverTimestamp();
    const sessionToSave = {
      userId,
      ...sessionData,
      createdAt: timestamp,
      duration: sessionData.duration || null,
      text: sessionData.text || ''
    };

    try {
      const docId = `${userId}_${Date.now()}`; // Create a deterministic ID
      await setDoc(doc(db, 'mindfulness', docId), sessionToSave);
      return docId;
    } catch (error) {
      console.error('Error creating mindfulness session:', error);
      // Retry once with a slight delay if first attempt fails
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));
        const retryDocId = `${userId}_${Date.now()}`;
        await setDoc(doc(db, 'mindfulness', retryDocId), sessionToSave);
        return retryDocId;
      } catch (retryError) {
        console.error('Error in retry attempt:', retryError);
        throw retryError;
      }
    }
  },

  async getSessions(userId) {
    const sessionsRef = collection(db, 'mindfulness');
    const sessionsQuery = query(
      sessionsRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );

    try {
      const querySnapshot = await getDocs(sessionsQuery);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting mindfulness sessions:', error);
      // Retry once with a slight delay if first attempt fails
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));
        const retrySnapshot = await getDocs(sessionsQuery);
        return retrySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      } catch (retryError) {
        console.error('Error in retry attempt:', retryError);
        throw retryError;
      }
    }
  }
}; 